<template>
  <div
    class="main hidescrollbar rank_box-main"
    v-if="GameList && GameList.length > 0"
    @touchmove="Playtouchmove"
  >
    <!-- <div class="ret_box">
      <div class="ret" @click="ret">
        <img class="ret_img" src="@/img/back.png" alt="" />
      </div>
      <div class="nav_text">{{ this.getGames().title }}</div>
    </div> -->
    <navBar v-if="!isKule" :text="$t('rank.title')"></navBar>
    <div
      :class="
        !isKule ? 'top rank_box pd_le pd-rg' : 'top_active rank_box pd_le pd-rg'
      "
    >
      <div class="rank_pm" @click="onPlay(1)">
        <img class="rank_bg" src="@/img/rank1.png" alt="" />
        <div class="rank_centent">
          <div class="rank_game">
            <img class="rank_game_crown" src="@/img/crown2.png" alt="" />
            <img
              class="rank_game_url"
              :src="this.getGames().gameList[1].imageSrc"
              alt=""
            />
          </div>
          <div class="rank_game_name">
            {{ this.getGames().gameList[1].name }}
          </div>
          <div class="rank_game_sum">
            {{ formateNumber(this.getGames().gameList[1].totalPlayer) }}
            {{ $t("index.player") }}
          </div>
        </div>
        <div class="rank_game_btns">
          <div class="rank_game_btn">{{ $t("index.open") }}</div>
        </div>
      </div>
      <div class="rank_pm" @click="onPlay(0)">
        <img class="rank_bg" src="@/img/rank2.png" alt="" />
        <div class="rank_centent">
          <div class="rank_game">
            <img class="rank_game_crown" src="@/img/crown1.png" alt="" />
            <img
              class="rank_game_url"
              :src="this.getGames().gameList[0].imageSrc"
              alt=""
            />
          </div>
          <div class="rank_game_name">
            {{ this.getGames().gameList[0].name }}
          </div>
          <div class="rank_game_sum">
            {{ formateNumber(this.getGames().gameList[0].totalPlayer) }}
            {{ $t("index.player") }}
          </div>
        </div>
        <div class="rank_game_btns">
          <div class="rank_game_btn">{{ $t("index.open") }}</div>
        </div>
      </div>
      <div class="rank_pm" @click="onPlay(2)">
        <img class="rank_bg" src="@/img/rank3.png" alt="" />
        <div class="rank_centent">
          <div class="rank_game">
            <img class="rank_game_crown" src="@/img/crown3.png" alt="" />
            <img
              class="rank_game_url"
              :src="this.getGames().gameList[2].imageSrc"
              alt=""
            />
          </div>
          <div class="rank_game_name">
            {{ this.getGames().gameList[2].name }}
          </div>
          <div class="rank_game_sum">
            {{ formateNumber(this.getGames().gameList[2].totalPlayer) }}
            {{ $t("index.player") }}
          </div>
        </div>
        <div class="rank_game_btns">
          <div class="rank_game_btn">{{ $t("index.open") }}</div>
        </div>
      </div>
    </div>
    <div
      class="rank_list pd-rg"
      v-for="(item, index) in this.getGames().gameList"
      v-if="index > 2"
      @click="onPlay(index)"
      @touchstart="Playtouchstart($event, index, 2)"
      @touchend="Playtouchend($event, index, 2)"
      :key="index"
    >
      <div class="rank_list_game">
        <div class="rank_list_sum">{{ index + 1 }}</div>
        <div class="rank_list_url">
          <img class="rank_list_img" :src="item.imageSrc" alt="" />
        </div>
        <div class="rank_list_text">
          <div class="rank_game_title">{{ item.name }}</div>
          <div class="rank_list_player">
            {{ formateNumber(item.totalPlayer) }} {{ $t("index.player") }}
          </div>
        </div>
      </div>
      <div
        class="rank_list_btn"
        :class="bg_index == index && bg_index != -1 ? 'btn-active' : ''"
      >
        {{ $t("index.open") }}
      </div>
    </div>

    <div class="more_game">
      <div class="more_game_height1"></div>
      <div class="loading" v-if="!isEnd">
        <img class="loading_img" src="@/img/gif.gif" />
        <span class="loading_text">{{ $t("index.recommend") }}</span>
      </div>
      <div v-if="isEnd">{{ $t("index.nogame") }}</div>
      <div class="more_game_height"></div>
    </div>
    <!-- showShare -->
    <div class="share" v-if="false">
      <div class="head_bg"></div>
      <div class="share_box">
        <div class="share_colse" @click="ColseShare">
          <img class="share_colse_img" src="@/img/colse.png" alt="" />
        </div>
        <div class="share_text">
          {{ $t("index.Sharegame") }}
        </div>
        <div class="share_url">
          <img class="share_img" :src="ShareURL" alt="" />
        </div>
        <div class="head_button" @click="SendShare">
          {{ $t("index.Share") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import navBar from "@/components/nav/navBar";
import configs from "@/config/config.js";
export default {
  components: {
    navBar,
  },
  data() {
    return {
      isAndroid: true,
      isiOS: false,
      // 分享开关
      showShare: false,
      isEnd: true,
      ShareURL: "",
      bg_index: -1,
      isKule: false,
    };
  },
  created() {
    this.GetGameList();
    if (window.TgaBridge) {
      this.isBridge = true;
    }
    console.log("jinru");
    var self = this;
    var u = navigator.userAgent;
    this.isKule = u.indexOf("KuleWebview") > -1;
    console.log(this.isKule);
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    console.log("this.isAndroid", this.isAndroid);
    console.log("this.isiOS", this.isiOS);
    console.log("this.GameList", this.GameList);
    // setTimeout(function () {
    //   if (!self.GameList || self.GameList.length <= 0) {
    //     self.$router.go(-1);
    //   }
    // }, 1000);

    // this.$nextTick(() => {
    // 	const el = document.querySelector('.main');
    // 	const offsetHeight = el.offsetHeight;
    // 	el.onscroll = () => {
    // 		const scrollTop = el.scrollTop;
    // 		const scrollHeight = el.scrollHeight;
    // 		if (offsetHeight + scrollTop - scrollHeight >= -1) {
    // 			// 需要执行的代码
    // 			console.log('已滚动到底部');
    // 		}
    // 	};
    // });
  },
  mounted() {
    var timestam = 1000 * 60 * 60 * 6;
    var time = new Date().getTime();
    if (
      localStorage.getItem("ShareGame") &&
      localStorage.getItem("Sharetime")
    ) {
      var Sharetime = JSON.parse(localStorage.getItem("Sharetime"));
      if (time - Sharetime <= timestam) {
        var ShareGame = JSON.parse(localStorage.getItem("ShareGame"));
        self.showShare = true;
        self.ShareURL = ShareGame.ImageSrc;
      } else {
        localStorage.removeItem("ShareGame");
        localStorage.removeItem("Sharetime");
      }
    }

    if (self.isAndroid) {
      window.onbeforeunload = function (e) {
        var e = window.event || e;
        self.hintloading = false;
      };
    } else if (self.isiOS) {
      window.addEventListener("pagehide", function () {
        self.hintloading = false;
      });
    }
  },
  computed: {
    ...mapState("game", ["GameList"]),
    ...mapState("user", ["userInfo"]),
  },
  methods: {
    ...mapActions("game", [
      "changeRecentPlayList",
      "gamePlay",
      "GetShareUrl",
      "ActionList",
      "ActionGameList",
      "ActionGameIdList",
    ]),
    ...mapActions("user", ["UserFinishTask"]),

    getGames() {
      return this.GameList[this.GameList.length - 1];
    },

    formateNumber(data) {
      return configs.formateNumber(data);
    },

    // 分享关闭
    ColseShare() {
      localStorage.removeItem("ShareGame");
      localStorage.removeItem("Sharetime");
      this.showShare = false;
    },
    async GetGameList() {
      let lang = localStorage.getItem("lang");

      // 判断是否有
      if (!localStorage.getItem("BIPGameList")) {
        const res = await this.ActionGameList({
          $axios: this.$axios,
          lang: lang,
        });
      } else {
        const res = await this.ActionGameIdList({
          $axios: this.$axios,
          lang: lang,
        });
        if (res == false) {
          const res = await this.ActionGameList({
            $axios: this.$axios,
            lang: lang,
          });
        }
      }
    },

    // 点击分享
    async SendShare() {
      var ShareGame = JSON.parse(localStorage.getItem("ShareGame"));
      let lang = localStorage.getItem("lang");
      const data = await this.GetShareUrl({
        $axios: this.$axios,
        gameId: ShareGame.GameId + "",
        lang: lang,
        type: "bip",
      });

      location.href = data;
    },

    // 点击去玩游戏
    async onPlay(index) {
      var self = this;
      var item = this.getGames().gameList[index];
      console.log("-----------", item);
      // 点击去玩就添加数据到缓存
      var time = new Date().getTime();
      localStorage.setItem("ShareGame", JSON.stringify(item));
      localStorage.setItem("Sharetime", JSON.stringify(time));

      this.changeRecentPlayList({
        $axios: this.$axios,
        recentPlay: item,
        userId: this.userInfo.id,
      });
      // 新版统计
      window.dataKule.push("track", "game", "play-btn", {
        id: item.gameId,
      });
      const res = await this.gamePlay({
        $axios: this.$axios,
        $router: this.$router,
        url: item.playUrl,gameId: item.gameId,
        ImageSrc: item.imageSrc,
        $root: this.$root,
      });
      this.hintloading = res;
      // 只要去玩就发送签到
      // await self.UserFinishTask({
      // 	$axios: self.$axios,
      // 	// self.actionlist.actionId
      // 	actionId: 1,
      // 	taskId: 'task02',
      // 	objectId: item.GameId
      // });
    },
    ret() {
      this.$router.go(-1);
    },
    Playtouchstart(e, index) {
      this.bg_index = index;

      this.bg_scrollTop = document.querySelector(".rank_box-main").scrollTop;
    },
    Playtouchend(e, index) {
      this.bg_index = -1;
    },
    Playtouchmove(e, index) {
      var top = document.querySelector(".rank_box-main").scrollTop;
      if (this.bg_scrollTop - top > 8 || top - this.bg_scrollTop > 8) {
        this.bg_index = -1;
      }
    },
  },
};
</script>

<style scoped="scoped">
.hidescrollbar::-webkit-scrollbar {
  width: 0;
}
*::-webkit-scrollbar {
  width: 0;
}
.main {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
  overflow: auto;
}

.ret_box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.5rem;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background-color: #fff;
}
.nav_text {
  font-size: 0.4rem;
  color: #222222;
  font-weight: bold;
}
.ret {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  box-sizing: border-box;
  width: 1rem;
  height: 1.5rem;
  padding: 0 0 0 0.51rem;
  display: flex;
  align-items: center;
}
.ret_img {
  width: 0.33rem;
  height: 0.54rem;
}
.pd-rg {
  padding-right: 0.4rem;
}
.pd_le {
  padding-left: 0.4rem;
}
.top {
  margin-top: calc(2.33rem + 1.5rem);
}
.top_active {
  margin-top: calc(2.33rem);
}
.rank_box {
  /* margin-top: 2.33rem; */
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.rank_box {
  /* margin-top: 2.33rem; */
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.rank_box .rank_pm:nth-of-type(1) {
  width: 3.15rem;
  height: 3.8rem;
  border-radius: 0.3rem;
  background-image: linear-gradient(45deg, #ff5671 0%, #ff1038 100%);
  position: relative;
}
.rank_box .rank_pm:nth-of-type(2) {
  width: 3.15rem;
  height: 4.3rem;
  border-radius: 0.3rem;
  background-image: linear-gradient(45deg, #fea700 0%, #fec200 100%);
  position: relative;
}
.rank_box .rank_pm:nth-of-type(3) {
  width: 3.15rem;
  height: 3.3rem;
  border-radius: 0.3rem;
  background-image: linear-gradient(45deg, #0092f2 0%, #019aff 100%);
  box-shadow: 0px 0px 16px 1px rgba(15, 21, 69, 0.09);
  position: relative;
}
.rank_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.rank_centent {
  position: relative;
  z-index: 2;
  top: -1.99rem;
}

.rank_game {
  position: relative;
  /* top: -1.6rem; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rank_game_url {
  margin-top: 0.16rem;
  width: 2.02rem;
  height: 2.02rem;
  /* background-color: #ffd245; */
  border-radius: 0.3rem;
  border: solid 0.05rem #eeeeee;
  object-fit: cover;
}
.rank_game_crown {
  width: 0.87rem;
  height: 0.58rem;
}

.rank_box .rank_pm:nth-of-type(1) .rank_game_name {
  margin: 0.4rem auto 0;
}

.rank_box .rank_pm:nth-of-type(2) .rank_game_name {
  margin: 0.6rem auto 0;
}

.rank_box .rank_pm:nth-of-type(3) .rank_game_name {
  margin: 0.15rem auto 0;
}
.rank_game_name {
  font-weight: bold;
  color: #ffffff;
  font-size: 0.42rem;
  width: 2.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.rank_game_sum {
  margin: 0.08rem auto 0;
  font-size: 0.3rem;
  color: #eeeeee;
  width: 2.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.rank_game_btns {
  width: 100%;
  position: absolute;
  z-index: 2;
  bottom: 0.3rem;
  left: 0;
}
.rank_game_btn {
  width: 2.21rem;
  height: 0.76rem;
  background-color: #ffffff;
  /* 	box-shadow: 0px 0.1rem 0.1rem 0px
				#f2aa00; */
  border-radius: 0.38rem;
  font-size: 0.36rem;

  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.rank_box .rank_pm:nth-of-type(1) .rank_game_btn {
  color: #ff3455;
}

.rank_box .rank_pm:nth-of-type(2) .rank_game_btn {
  color: #feb300;
}

.rank_box .rank_pm:nth-of-type(3) .rank_game_btn {
  color: #0097f9;
}

.rank_list {
  margin-top: 0.57rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.rank_list_game {
  display: flex;
  align-items: center;
}
.rank_list_sum {
  width: 1.12rem;
  text-align: center;
  font-family: "DINENGSCHRIFTSTD";
  color: var(--rankSumColor);
  font-size: 0.74rem;
}

.rank_list_img {
  width: 1.79rem;
  height: 1.79rem;
  border-radius: 0.3rem;
  border: solid 0.05rem #eeeeee;
}
.rank_list_text {
  margin-left: 0.3rem;
}
.rank_game_title {
  width: 4.7rem;
  font-weight: bold;
  font-size: 0.42rem;
  color: var(--rankColor);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rank_list_player {
  margin-top: 0.2rem;
  font-size: 0.3rem;
  color: #999999;
}

.rank_list_btn {
  width: 1.81rem;
  height: 0.76rem;
  background-color: var(--rankBackgroundBtn);
  border-radius: 0.38rem;
  color: var(--rankColorBtn);
  font-size: 0.36rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-active {
  color: var(--rankColorBtnActive);
  background-color: var(--rankBackgroundBtnActive);
}

/* 页面加载 */
.more_game {
  box-sizing: border-box;
  font-size: 0.25rem;
  width: 100%;
  text-align: center;
  color: var(--rankmore);
  /* padding-top: 0.41rem; */
  /* margin-top: 0.41rem;
	       margin-bottom: 1.50rem; */
  opacity: 0.3;
  background-color: var(--bg);
}
.more_game_height {
  width: 100%;
  height: 1.16rem;
  background-color: var(--bg);
}
.more_game_height1 {
  width: 100%;
  height: 1.16rem;
  background-color: var(--bg);
}

.loading {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: center;
}
.loading_img {
  width: 0.45rem;
  height: 0.45rem;
  margin-right: 0.2rem;
}

.share {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share_bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.share_box {
  position: relative;
  z-index: 2;
  width: 7.6rem;
  height: 8rem;
  background-color: #ffffff;
  border-radius: 0.45rem;
}
.share_text {
  margin-top: 1.2rem;
  font-size: 0.48rem;
  color: #1b1b1b;
  padding: 0 1.2rem;
  text-align: center;
}
.share_url {
  position: relative;
  width: 2.18rem;
  height: 2.18rem;
  margin: 0.66rem auto 0;
}
.share_img {
  box-sizing: border-box;
  object-fit: cover;
  width: 2.18rem;
  height: 2.18rem;
  border-radius: 0.2rem;
  border: 0.06rem solid #ffffff;
  box-shadow: 0px 0.07rem 0.15rem 0px rgba(0, 0, 0, 0.2);
}

.share_colse {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.29rem 0.24rem;
}
.share_colse_img {
  width: 0.73rem;
  height: 0.73rem;
}

.share_input {
  font-size: 0.48rem;
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

.share_button {
  margin: 0.85rem auto 0;
  width: 6.01rem;
  height: 1.21rem;
  background-color: #03a9f5;
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.42rem;
}
</style>



// WEBPACK FOOTER //
// src/components/gamerank.vue